class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    connectedCallback() {
        this.initEmptyCartObserver();
    }

    initEmptyCartObserver() {
        const emptyCartObserver = new MutationObserver(() => {
            const rows = this.querySelectorAll('cart-drawer .cart-items__list > li');
            const isEmpty = rows.length === 0;
            this.classList.toggle('is-empty', isEmpty);

            const cartDrawerItems = this.querySelector('cart-drawer-items');
            cartDrawerItems.classList.toggle('is-empty', isEmpty);
        });

        emptyCartObserver.observe(this, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
            this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement =
                    this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute(
                'aria-expanded',
                !event.currentTarget.closest('details').hasAttribute('open')
            );
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState, openOnFinish = true) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') &&
            this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            );
        });

        if (openOnFinish) {
            setTimeout(() => {
                this.querySelector('#CartDrawer-Overlay').addEventListener(
                    'click',
                    this.close.bind(this)
                );
                this.open();
            });
        }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    async refreshCart() {
        const updatedCart = await Shopify.renderSection({
            section_id: this.getSectionsToRender()
                .map((section) => section.id)
                .join(','),
            returnRawResponse: true,
        });

        this.renderContents({ sections: updatedCart }, false);
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class popupOrthotics extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('.cart-drawer__overlay').addEventListener('click', this.close.bind(this));
        this.querySelector('button').addEventListener('click', this.close.bind(this));
  
    }
    open() {
        setTimeout(() => {
            this.classList.add('animate', 'active', 'open');
        },175);
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('open');
        setTimeout(() => {
            this.classList.remove('active');
        },200);

        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }
}

customElements.define('popup-orthotics', popupOrthotics);

/* OD Mini-cart Clear Cart — 2026-10-16. Append to the theme's cart-drawer.js. */
(function () {
  'use strict';
  if (window.ODMiniCartClear || !window.fetch) return;
  const state = window.ODMiniCartClear = { version: '20261016-3', busy: false };
  const originalFetch = window.fetch.bind(window);
  let pending = 0;
  let lastActivity = 0;
  let verifyOnly = false;
  let statusText = '';

  function root() {
    const path = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof path === 'string' && /^\/(?:[a-z0-9-]+\/)*$/i.test(path) ? path : '/';
  }

  // Observe only same-origin cart/product requests. During a clear, reject new
  // mutations instead of queuing an old wizard add to run AFTER the clear.
  window.fetch = function (input, options) {
    let url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href); }
    catch (error) { return originalFetch(input, options); }
    const local = url.origin === location.origin;
    const mutation = local && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    const tracked = mutation || (local && /\/(?:cart\.js|products\/[^/]+\.js)$/.test(url.pathname));
    if (mutation && state.busy) return Promise.reject(new Error('Please wait for Clear Cart to finish, then add your items again.'));
    if (!tracked) return originalFetch(input, options);
    pending++;
    lastActivity = Date.now();
    const finished = function () { pending--; lastActivity = Date.now(); };
    return originalFetch(input, options).then(function (response) {
      // Keep the original response untouched for the theme/wizard caller.
      response.clone().arrayBuffer().then(finished, finished);
      return response;
    }, function (error) { finished(); throw error; });
  };

  function settle() {
    const started = Date.now();
    return new Promise(function (resolve, reject) {
      function check() {
        if (pending === 0 && Date.now() - lastActivity >= 650) return resolve();
        if (Date.now() - started > 15000) return reject(new Error('The cart is still updating. Please wait and try again.'));
        setTimeout(check, 50);
      }
      check();
    });
  }

  function readCart() {
    const controller = new AbortController();
    const timer = setTimeout(function () { controller.abort(); }, 15000);
    return originalFetch(root() + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart verification failed.');
      return response.json();
    }).then(function (cart) {
      if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0 || !Array.isArray(cart.items)) {
        throw new Error('Invalid cart verification.');
      }
      return cart;
    }).finally(function () { clearTimeout(timer); });
  }

  function setStatus(drawer, text) {
    statusText = text;
    const node = drawer.querySelector('[data-od-clear-status]');
    if (node && node.textContent !== text) node.textContent = text;
  }

  function updateControls(drawer) {
    drawer.querySelectorAll('[data-od-clear-start], [data-od-clear-confirm], [data-od-clear-cancel]').forEach(function (button) {
      button.disabled = state.busy;
    });
    const confirm = drawer.querySelector('[data-od-clear-confirm]');
    if (confirm) confirm.textContent = state.busy ? 'Clearing…' : (verifyOnly ? 'Check cart' : 'Clear Cart');
    drawer.classList.toggle('od-cart-clearing', state.busy);
    drawer.setAttribute('aria-busy', state.busy ? 'true' : 'false');
  }

  function showConfirmation(drawer, show) {
    const panel = drawer.querySelector('[data-od-clear-panel]');
    const button = drawer.querySelector('[data-od-clear-start]');
    if (!panel || !button) return;
    panel.hidden = !show;
    button.setAttribute('aria-expanded', show ? 'true' : 'false');
    (show ? panel.querySelector('[data-od-clear-cancel]') : button).focus();
  }

  function forgetCheckoutPrompt() {
    try {
      sessionStorage.removeItem('odScanOpenCartAfterReload');
      sessionStorage.removeItem('odScanCheckoutAfterReload');
    } catch (error) { /* Storage may be disabled; the visible prompt still closes. */ }
    const prompt = document.getElementById('odScanCheckoutPrompt');
    if (prompt) {
      if (prompt.open && typeof prompt.close === 'function') prompt.close();
      prompt.remove();
    }
  }

  async function displayEmpty(drawer, cart, sections) {
    forgetCheckoutPrompt();
    drawer.dispatchEvent(new CustomEvent('od:cart-clear-confirmed'));
    const expected = drawer.getSectionsToRender();
    if (sections && expected.every(function (section) { return typeof sections[section.id] === 'string'; })) {
      drawer.renderContents({ sections: sections }, false);
    } else {
      await drawer.refreshCart();
    }
    drawer.classList.add('is-empty');
    const items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.add('is-empty');
    document.dispatchEvent(new CustomEvent('cartUpdate', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    const empty = drawer.querySelector('.drawer__inner-empty');
    if (empty) {
      const target = empty.querySelector('a') || empty.querySelector('button');
      if (typeof trapFocus === 'function') trapFocus(empty, target);
      else if (target) target.focus();
    }
  }

  async function clear(drawer) {
    if (state.busy) return;
    if (document.querySelector('iframe[title="Orthotics Direct Finder"]')) {
      setStatus(drawer, 'Please finish or close the fitting wizard before clearing your cart.');
      return;
    }
    state.busy = true;
    updateControls(drawer);
    setStatus(drawer, verifyOnly ? 'Checking your cart…' : 'Clearing your cart…');
    const slow = setTimeout(function () {
      setStatus(drawer, 'Still waiting for Shopify. Please keep this cart open.');
    }, 12000);
    let verifiedEmpty = false;
    let sections = null;
    try {
      await settle();
      if (!verifyOnly) {
        verifyOnly = true;
        // Do not abort or retry a pending write: its eventual result could empty
        // newly added items. Keep the guard until Shopify responds or disconnects.
        try {
          const response = await originalFetch(root() + 'cart/clear.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ sections: drawer.getSectionsToRender().map(function (s) { return s.id; }), sections_url: location.pathname })
          });
          const body = await response.json();
          if (response.ok && body.item_count === 0) sections = body.sections;
        } catch (error) { /* Reconcile the actual cart before deciding the outcome. */ }
      }
      const cart = await readCart();
      if (cart.item_count !== 0 || cart.items.length !== 0) {
        verifyOnly = false;
        setStatus(drawer, 'Your cart still contains items. Choose Clear Cart to try again.');
        return;
      }
      verifiedEmpty = true;
      await displayEmpty(drawer, cart, sections);
      verifyOnly = false;
      statusText = '';
    } catch (error) {
      if (verifiedEmpty) {
        // The write is confirmed; a failed section render needs a fresh page,
        // never another clear request. The launcher reopens the native drawer.
        try { sessionStorage.setItem('odScanOpenCartAfterReload', '1'); } catch (storageError) { /* optional */ }
        location.reload();
      } else {
        setStatus(drawer, verifyOnly ? 'Could not verify your cart. Choose Check cart before trying again.' : error.message);
      }
    } finally {
      clearTimeout(slow);
      state.busy = false;
      updateControls(drawer);
    }
  }

  const css = document.createElement('style');
  css.id = 'od-mini-cart-clear-styles';
  css.textContent = `
    .od-cart-clear { flex:none; padding:0 1rem .5rem; color:#35254b; }
    cart-drawer.is-empty:not(.od-cart-clear-recovery) .od-cart-clear { display:none; }
    .od-cart-clear__recovery-note { display:none; }
    .od-cart-clear-recovery .od-cart-clear { margin:0 0 16px; text-align:left; }
    .od-cart-clear-recovery .od-cart-clear__recovery-note { display:block; margin:0 0 8px; font-size:16px; line-height:1.5; }
    .od-cart-clear__toolbar { display:flex; justify-content:flex-end; }
    .od-cart-clear button { font:inherit; cursor:pointer; }
    .od-cart-clear__start { display:inline-flex; align-items:center; gap:6px; min-height:36px; padding:4px 8px; border:0; background:transparent; color:#59416e; font-size:12px!important; text-decoration:underline; text-underline-offset:3px; }
    .od-cart-clear__start svg { width:16px; height:16px; flex:none; }
    .od-cart-clear button:focus-visible { outline:2px solid #68409a; outline-offset:3px; }
    .od-cart-clear button:disabled { opacity:.6; cursor:wait; }
    .od-cart-clear__panel { padding:12px; border:1px solid #d9cde5; border-radius:10px; background:#faf7fd; font-size:14px; }
    .od-cart-clear__panel[hidden] { display:none; }
    .od-cart-clear__question { margin:0 0 10px; font-weight:600; }
    .od-cart-clear__actions { display:flex; gap:10px; }
    .od-cart-clear__actions button { min-height:40px; padding:8px 15px; border:1px solid #65418a; border-radius:7px; font-size:13px; }
    .od-cart-clear__confirm { background:#65418a; color:#fff; }
    .od-cart-clear__cancel { background:#fff; color:#49315f; }
    .od-cart-clear__status { margin:8px 0 0; font-size:13px; line-height:1.4; }
    .od-cart-clear__status:empty { display:none; }
    .od-cart-clearing cart-drawer-items, .od-cart-clearing .drawer__footer { pointer-events:none; opacity:.6; }
  `;
  document.head.appendChild(css);

  function attach(drawer) {
    let knownCount = null;
    let checking = false;
    let availabilityVersion = 0;
    let wasEmpty = null;
    let wasOpen = null;
    function position() {
      const wrapper = drawer.querySelector('.od-cart-clear');
      if (!wrapper) return;
      const recovery = drawer.classList.contains('is-empty') && knownCount > 0;
      drawer.classList.toggle('od-cart-clear-recovery', recovery);
      const empty = drawer.querySelector('.cart-drawer__empty-content') || drawer.querySelector('.drawer__inner-empty');
      const header = drawer.querySelector('.drawer__header');
      const heading = empty && empty.querySelector('.cart__empty-text');
      if (heading) {
        if (!heading.hasAttribute('data-od-original-heading')) heading.setAttribute('data-od-original-heading', heading.textContent);
        const label = recovery ? 'Your cart' : heading.getAttribute('data-od-original-heading');
        if (heading.textContent !== label) heading.textContent = label;
      }
      if (recovery && empty) {
        const before = empty.querySelector('a');
        if (wrapper.parentElement !== empty || (before && wrapper.nextSibling !== before)) empty.insertBefore(wrapper, before);
      } else if (header && header.nextElementSibling !== wrapper) {
        header.insertAdjacentElement('afterend', wrapper);
      }
    }
    function checkAvailability() {
      if (checking || state.busy) return;
      checking = true;
      const version = availabilityVersion;
      // The legacy theme counts rendered rows and hides standalone Foam Kits.
      // Shopify's actual cart count is authoritative for this recovery control.
      readCart().then(function (cart) {
        if (version === availabilityVersion && !state.busy) { knownCount = cart.item_count; position(); }
      })
        .catch(function () { /* Keep the existing control; retry on the next open. */ })
        .finally(function () { checking = false; });
    }
    function watchVisibility() {
      const empty = drawer.classList.contains('is-empty');
      const open = drawer.classList.contains('active');
      const check = empty && (wasEmpty !== empty || (open && wasOpen !== open));
      wasEmpty = empty;
      wasOpen = open;
      position();
      if (check) checkAvailability();
    }
    function mount() {
      const header = drawer.querySelector('.drawer__header');
      if (!header) return;
      if (drawer.querySelector('.od-cart-clear')) { position(); return; }
      const wrapper = document.createElement('div');
      wrapper.className = 'od-cart-clear';
      wrapper.innerHTML = '<div class="od-cart-clear__toolbar"><button type="button" class="od-cart-clear__start" data-od-clear-start aria-label="Clear all items from cart" aria-expanded="false" aria-controls="ODClearCartPanel"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg>Clear Cart</button></div><div id="ODClearCartPanel" class="od-cart-clear__panel" data-od-clear-panel hidden><p class="od-cart-clear__question">Remove all items from your cart?</p><div class="od-cart-clear__actions"><button type="button" class="od-cart-clear__confirm" data-od-clear-confirm>Clear Cart</button><button type="button" class="od-cart-clear__cancel" data-od-clear-cancel>Cancel</button></div><p class="od-cart-clear__status" data-od-clear-status role="status" aria-live="polite"></p></div>';
      header.insertAdjacentElement('afterend', wrapper);
      const recoveryNote = document.createElement('p');
      recoveryNote.className = 'od-cart-clear__recovery-note';
      recoveryNote.textContent = 'Your cart still contains items. Clear it to start over.';
      wrapper.prepend(recoveryNote);
      setStatus(drawer, statusText);
      if (state.busy || verifyOnly) wrapper.querySelector('[data-od-clear-panel]').hidden = false;
      updateControls(drawer);
      position();
    }
    mount();
    new MutationObserver(mount).observe(drawer, { childList: true, subtree: true });
    new MutationObserver(watchVisibility).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    drawer.addEventListener('od:cart-clear-confirmed', function () { availabilityVersion++; knownCount = 0; position(); });
    watchVisibility();
    drawer.addEventListener('click', function (event) {
      const button = event.target.closest('button');
      if (state.busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (!button) return;
      if (button.hasAttribute('data-od-clear-start')) {
        event.preventDefault(); showConfirmation(drawer, true);
      } else if (button.hasAttribute('data-od-clear-cancel')) {
        event.preventDefault(); showConfirmation(drawer, false);
      } else if (button.hasAttribute('data-od-clear-confirm')) {
        event.preventDefault(); clear(drawer);
      }
    }, true);
    let consumedEscape = false;
    function escape(event) {
      if (event.key !== 'Escape') return;
      const panel = drawer.querySelector('[data-od-clear-panel]');
      if (state.busy || consumedEscape || (panel && !panel.hidden)) {
        event.preventDefault(); event.stopImmediatePropagation();
        consumedEscape = event.type === 'keydown';
        if (!state.busy && event.type === 'keydown') showConfirmation(drawer, false);
      }
    }
    drawer.addEventListener('keydown', escape, true);
    drawer.addEventListener('keyup', escape, true);
  }
  function start() { document.querySelectorAll('cart-drawer').forEach(attach); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
